<section class="elegibilidade" aria-labelledby="elegibilidade-titulo" data-testid="beneficios-elegibilidade">
  <header class="elegibilidade__topo">
    <span class="elegibilidade__icone" aria-hidden="true">
      <vivest-icon name="users" source="feather"></vivest-icon>
    </span>
    <div class="elegibilidade__titulo-grupo">
      <h2 id="elegibilidade-titulo" class="elegibilidade__titulo">Elegibilidade</h2>
      <p class="elegibilidade__descricao">Configure as regras de elegibilidade para cada benefício deste plano.</p>
    </div>
  </header>

  <!-- Verificações fixas do sistema: não parametrizáveis, mas valem junto com as regras. -->
  <details class="elegibilidade__aviso" data-testid="elegibilidade-validacoes-automaticas">
    <summary class="elegibilidade__aviso-resumo">
      <vivest-icon name="info" source="feather" aria-hidden="true"></vivest-icon>
      <span>
        Estas regras validam se o participante pode solicitar o benefício no autoatendimento.
        <!-- O texto do link acompanha o estado: abrir a lista ou recolher. -->
        <span class="elegibilidade__aviso-link elegibilidade__aviso-link--abrir">Ver verificações automáticas</span>
        <span class="elegibilidade__aviso-link elegibilidade__aviso-link--fechar">Ocultar</span>
      </span>
    </summary>
    <p class="elegibilidade__aviso-texto">Em toda solicitação, o sistema também confere:</p>
    <ul class="elegibilidade__aviso-lista">
      @for (validacao of validacoesAutomaticas; track validacao) {
        <li>{{ validacao }}</li>
      }
    </ul>
  </details>

  @if (rascunho()) {
    <div class="elegibilidade__blocos">
      <app-beneficios-lista
        [beneficios]="beneficios()"
        [selecionadoId]="selecionadoId()"
        [nomePlano]="nomePlano()"
        [editavel]="true"
        [idsNovos]="idsNovos()"
        [idsAlterados]="idsAlterados()"
        [pendente]="tentouSalvar() && selecionadoInvalido()"
        vazio="Nenhum benefício no plano. Use &quot;Adicionar Benefício&quot; para escolher os benefícios do plano."
        (selecionar)="selecionar($event)"
        (adicionar)="abrirAdicionar()"
        (ativar)="ativar($event.id, $event.ativo)"
        (excluir)="pedirExclusaoPorId($event)"
      />

      @if (selecionado(); as beneficio) {
        <section class="elegibilidade-parametros" aria-labelledby="elegibilidade-parametros-titulo">
          <div class="elegibilidade-parametros__cabecalho">
            <h3 id="elegibilidade-parametros-titulo" class="elegibilidade__subtitulo">
              Parâmetros de Elegibilidade:
              <span class="elegibilidade-parametros__beneficio" data-testid="elegibilidade-beneficio-nome">{{ beneficio.nome }}</span>
            </h3>
            <vivest-tag type="status" [variant]="beneficio.ativo ? 'success' : 'warning'" data-testid="elegibilidade-status">
              {{ beneficio.ativo ? 'Ativo' : 'Inativo' }}
            </vivest-tag>
          </div>

          <div class="elegibilidade-parametros__abas" role="tablist" aria-label="Parâmetros do benefício">
            @for (aba of abasRegras; track aba.id) {
              <button
                type="button"
                role="tab"
                class="elegibilidade-parametros__aba"
                [class.elegibilidade-parametros__aba--ativa]="abaRegras() === aba.id"
                [id]="'elegibilidade-aba-' + aba.id"
                [attr.aria-selected]="abaRegras() === aba.id"
                [attr.aria-controls]="'elegibilidade-painel-' + aba.id"
                [attr.data-testid]="'elegibilidade-aba-' + aba.id"
                (click)="selecionarAbaRegras(aba.id)"
              >
                {{ aba.rotulo }}
              </button>
            }
          </div>

          <form
            id="elegibilidade-painel-excecao"
            role="tabpanel"
            aria-labelledby="elegibilidade-aba-excecao"
            class="elegibilidade-regras"
            novalidate
            [hidden]="abaRegras() !== 'excecao'"
            [formGroup]="form"
            (submit)="$event.preventDefault(); salvar()"
            data-testid="elegibilidade-excecoes"
          >
            <div class="elegibilidade-campo elegibilidade-campo--texto">
              <label class="campanha-form-label" for="elegibilidade-excecoes">Regras de exceção</label>
              <p id="elegibilidade-excecoes-dica" class="elegibilidade-situacoes__dica">
                Descreva as situações que dispensam requisitos das regras gerais. Ex.: aposentadoria especial do INSS
                dispensa o desligamento e a idade mínima.
              </p>
              <textarea
                id="elegibilidade-excecoes"
                class="form-control campanha-form-control campanha-form-textarea"
                rows="5"
                placeholder="Descreva as exceções deste benefício"
                [attr.maxlength]="excecoesMaximo"
                formControlName="excecoes"
                [class.is-invalid]="!!erro('excecoes')"
                aria-describedby="elegibilidade-excecoes-dica elegibilidade-excecoes-contador"
                data-testid="elegibilidade-excecoes-texto"
              ></textarea>
              <p id="elegibilidade-excecoes-contador" class="elegibilidade__contador" data-testid="elegibilidade-excecoes-contador">
                {{ form.controls.excecoes.value.length }}/{{ excecoesMaximo }}
              </p>
              @if (erro('excecoes'); as mensagem) {
                <p class="elegibilidade__erro" role="alert">{{ mensagem }}</p>
              }
            </div>
          </form>

          <form
            id="elegibilidade-painel-gerais"
            role="tabpanel"
            aria-labelledby="elegibilidade-aba-gerais"
            class="elegibilidade-regras"
            novalidate
            [hidden]="abaRegras() !== 'gerais'"
            [formGroup]="form"
            (submit)="$event.preventDefault(); salvar()"
            data-testid="elegibilidade-form"
          >
            <p class="elegibilidade__descricao">
              O participante precisa atender a todos os blocos abaixo ao mesmo tempo.
            </p>

            <!-- Requisitos obrigatórios: todos se somam. -->
            <fieldset class="elegibilidade-bloco" aria-labelledby="elegibilidade-bloco-obrigatorios" data-testid="elegibilidade-bloco-obrigatorios">
              <div class="elegibilidade-bloco__cabecalho">
                <h4 id="elegibilidade-bloco-obrigatorios" class="elegibilidade-bloco__titulo">Requisitos obrigatórios</h4>
                <p class="elegibilidade-bloco__regra">Todos são exigidos.</p>
              </div>
              <div class="elegibilidade-bloco__conteudo">

                <div class="elegibilidade-campo">
                  <span id="elegibilidade-desligamento-rotulo" class="campanha-form-label">
                    Desligamento da patrocinadora obrigatório
                  </span>
                  <span class="elegibilidade-sim-nao">
                    <vivest-switch
                      formControlName="desligamentoObrigatorio"
                      aria-labelledby="elegibilidade-desligamento-rotulo"
                      data-testid="elegibilidade-desligamento"
                    ></vivest-switch>
                    {{ form.controls.desligamentoObrigatorio.value ? 'Sim' : 'Não' }}
                  </span>
                </div>

                <!-- Desmarcada continua visível até salvar, para poder ser marcada de volta. -->
                <fieldset
                  class="elegibilidade-campo elegibilidade-opcoes elegibilidade-situacoes"
                  [attr.aria-describedby]="erroSituacoes() ? 'elegibilidade-situacoes-erro' : 'elegibilidade-situacoes-descricao'"
                  data-testid="elegibilidade-situacoes"
                >
                  <legend class="campanha-form-label">
                    Situação do participante elegível<span class="campanha-form-required" aria-hidden="true">*</span>
                  </legend>
                  <p id="elegibilidade-situacoes-descricao" class="elegibilidade-situacoes__dica">
                    Basta estar em uma delas. Desmarque uma situação para tirá-la da lista.
                  </p>

                  @if (situacoesVisiveis().length) {
                    <ul class="elegibilidade-situacoes__lista" data-testid="elegibilidade-situacoes-lista">
                      @for (situacao of situacoesVisiveis(); track situacao) {
                        <li
                          class="elegibilidade-situacoes__item"
                          [class.elegibilidade-situacoes__item--desmarcado]="!situacaoMarcada(situacao)"
                        >
                          <vivest-checkbox
                            label-variant="multi-line"
                            name="situacoes-elegiveis"
                            [value]="situacao"
                            [checked]="situacaoMarcada(situacao)"
                            (change)="marcarSituacao(situacao, $any($event.target).checked)"
                            [attr.data-testid]="'elegibilidade-situacao-' + situacao"
                          >
                            {{ rotuloSituacao(situacao) }}
                          </vivest-checkbox>
                        </li>
                      }
                    </ul>
                  } @else {
                    <p class="elegibilidade__vazio" data-testid="elegibilidade-situacoes-vazio">
                      Nenhuma situação cadastral. Use "Adicionar situação" para escolher as situações elegíveis.
                    </p>
                  }

                  <vivest-button
                    class="elegibilidade-bloco__acao"
                    variant="outline"
                    size="sm"
                    data-testid="elegibilidade-situacoes-adicionar"
                    (click)="selecionandoSituacoes.set(true)"
                  >
                    <vivest-icon slot="icon-left" name="plus" source="feather"></vivest-icon>
                    Adicionar situação
                  </vivest-button>
                  @if (erroSituacoes(); as mensagem) {
                    <p id="elegibilidade-situacoes-erro" class="elegibilidade__erro" role="alert" data-testid="elegibilidade-situacoes-erro">
                      {{ mensagem }}
                    </p>
                  }
                </fieldset>

                <div class="elegibilidade-campo">
                  <label class="campanha-form-label" for="elegibilidade-servico">
                    Tempo mínimo de serviço na patrocinadora
                  </label>
                  <div class="elegibilidade-prazo">
                    <input
                      id="elegibilidade-servico"
                      type="number"
                      inputmode="numeric"
                      min="0"
                      step="1"
                      placeholder="0"
                      class="form-control campanha-form-control elegibilidade-prazo__valor"
                      formControlName="tempoMinimoServico"
                      [class.is-invalid]="!!erro('tempoMinimoServico')"
                      [attr.aria-describedby]="erro('tempoMinimoServico') ? 'elegibilidade-servico-erro' : 'elegibilidade-servico-dica'"
                      data-testid="elegibilidade-servico"
                    />
                    <div
                      class="elegibilidade-prazo__unidades"
                      role="radiogroup"
                      aria-label="Unidade do tempo mínimo de serviço"
                      data-testid="elegibilidade-servico-unidade"
                    >
                      @for (unidade of unidadesTempo; track unidade.value) {
                        <label
                          class="elegibilidade-prazo__unidade"
                          [class.elegibilidade-prazo__unidade--ativa]="form.controls.unidadeTempoServico.value === unidade.value"
                        >
                          <input
                            type="radio"
                            class="elegibilidade-prazo__radio"
                            name="unidadeTempoServico"
                            [value]="unidade.value"
                            formControlName="unidadeTempoServico"
                            [attr.data-testid]="'elegibilidade-servico-unidade-' + unidade.value"
                          />
                          {{ unidade.label }}
                        </label>
                      }
                    </div>
                  </div>
                  @if (!erro('tempoMinimoServico')) {
                    <p id="elegibilidade-servico-dica" class="elegibilidade-situacoes__dica">Deixe em branco se não houver exigência.</p>
                  }
                  @if (erro('tempoMinimoServico'); as mensagem) {
                    <p id="elegibilidade-servico-erro" class="elegibilidade__erro" role="alert">{{ mensagem }}</p>
                  }
                </div>
              </div>
            </fieldset>

            <!-- Idade e vinculação: alternativas, basta uma. -->
            <fieldset class="elegibilidade-bloco" aria-labelledby="elegibilidade-bloco-combinacoes" formArrayName="combinacoes" data-testid="elegibilidade-bloco-combinacoes">
              <div class="elegibilidade-bloco__cabecalho">
                <h4 id="elegibilidade-bloco-combinacoes" class="elegibilidade-bloco__titulo">Idade e tempo de vinculação ao plano</h4>
                <p class="elegibilidade-bloco__regra">Basta atender a uma combinação. Deixe sem combinações se o benefício não exigir idade nem vinculação.</p>
              </div>
              <div class="elegibilidade-bloco__conteudo">

                @if (form.controls.combinacoes.length) {
                  <ol class="elegibilidade-alternativas" aria-label="Combinações de idade e vinculação">
                    @for (combinacao of form.controls.combinacoes.controls; track combinacao; let i = $index; let primeira = $first) {
                      <li class="elegibilidade-alternativas__item" [attr.data-testid]="'elegibilidade-combinacao-' + i">
                        @if (!primeira) {
                          <span class="elegibilidade-ou" aria-hidden="true">ou</span>
                        }
                        <div class="elegibilidade-combinacao" [formGroupName]="i">
                          <div class="elegibilidade-campo">
                            <label class="campanha-form-label" [for]="'elegibilidade-idade-' + i">Idade mínima (anos)</label>
                            <input
                              [id]="'elegibilidade-idade-' + i"
                              type="number"
                              inputmode="numeric"
                              min="0"
                              [max]="anosMaximo"
                              step="1"
                              placeholder="Não exigida"
                              class="form-control campanha-form-control"
                              formControlName="idadeMinima"
                              [class.is-invalid]="!!erroCombinacao(i)"
                              [attr.aria-describedby]="erroCombinacao(i) ? 'elegibilidade-combinacao-erro-' + i : null"
                              data-testid="elegibilidade-idade"
                            />
                          </div>
                          <span class="elegibilidade-combinacao__mais" aria-hidden="true">+</span>
                          <div class="elegibilidade-campo">
                            <label class="campanha-form-label" [for]="'elegibilidade-vinculacao-' + i">
                              Vinculação ao plano (anos)
                            </label>
                            <input
                              [id]="'elegibilidade-vinculacao-' + i"
                              type="number"
                              inputmode="numeric"
                              min="0"
                              [max]="anosMaximo"
                              step="1"
                              placeholder="Não exigida"
                              class="form-control campanha-form-control"
                              formControlName="tempoMinimoVinculacao"
                              [class.is-invalid]="!!erroCombinacao(i)"
                              [attr.aria-describedby]="erroCombinacao(i) ? 'elegibilidade-combinacao-erro-' + i : null"
                              data-testid="elegibilidade-vinculacao"
                            />
                          </div>
                          <vivest-icon-button
                            class="elegibilidade-combinacao__remover"
                            variant="outline"
                            size="sm"
                            icon="trash-2"
                            icon-source="feather"
                            [attr.aria-label]="'Excluir combinação ' + (i + 1)"
                            data-testid="elegibilidade-combinacao-excluir"
                            (click)="removerCombinacao(i)"
                          ></vivest-icon-button>
                        </div>
                        @if (erroCombinacao(i); as mensagem) {
                          <p [id]="'elegibilidade-combinacao-erro-' + i" class="elegibilidade__erro" role="alert">{{ mensagem }}</p>
                        }
                      </li>
                    }
                  </ol>
                }

                <vivest-button
                  class="elegibilidade-bloco__acao"
                  variant="outline"
                  size="sm"
                  data-testid="elegibilidade-combinacao-adicionar"
                  (click)="adicionarCombinacao()"
                >
                  <vivest-icon slot="icon-left" name="plus" source="feather"></vivest-icon>
                  {{ form.controls.combinacoes.length ? 'Adicionar alternativa' : 'Adicionar combinação' }}
                </vivest-button>
              </div>
            </fieldset>

            <!-- Comprovação documental: alternativas, basta uma. -->
            <fieldset
              class="elegibilidade-bloco"
              aria-labelledby="elegibilidade-bloco-comprovacoes"
              data-testid="elegibilidade-bloco-comprovacoes"
            >
              <div class="elegibilidade-bloco__cabecalho">
                <h4 id="elegibilidade-bloco-comprovacoes" class="elegibilidade-bloco__titulo">Comprovação</h4>
                <p class="elegibilidade-bloco__regra">Basta apresentar um dos documentos marcados. Deixe tudo desmarcado se o benefício não exigir comprovação.</p>
              </div>
              <div class="elegibilidade-bloco__conteudo">
                <div class="elegibilidade-opcoes__itens">
                  @for (opcao of comprovacoesOpcoes(); track opcao.value) {
                    <vivest-checkbox
                      label-variant="multi-line"
                      name="comprovacoes"
                      [value]="opcao.value"
                      [checked]="comprovacaoMarcada(opcao.value)"
                      (change)="marcarComprovacao(opcao.value, $any($event.target).checked)"
                      [attr.data-testid]="'elegibilidade-comprovacao-' + opcao.value"
                    >
                      {{ opcao.label }}
                    </vivest-checkbox>
                  }
                </div>
              </div>
            </fieldset>

            <!-- Impedimentos: quem atende a uma das regras não pode solicitar este benefício. -->
            <section class="elegibilidade-bloco" aria-labelledby="elegibilidade-bloco-impedimentos" data-testid="elegibilidade-bloco-impedimentos">
              <div class="elegibilidade-bloco__cabecalho">
                <h4 id="elegibilidade-bloco-impedimentos" class="elegibilidade-bloco__titulo">Não pode ser elegível a</h4>
                <p class="elegibilidade-bloco__regra">Quem cair em uma destas regras não pode solicitar {{ beneficio.nome }}.</p>
              </div>
              <div class="elegibilidade-bloco__conteudo">
                @if (beneficio.regras.impedimentos.length) {
                  <ol class="elegibilidade-impedimentos" [attr.aria-label]="'Regras de impedimento de ' + beneficio.nome">
                    @for (regra of beneficio.regras.impedimentos; track regra.id; let i = $index) {
                      <li class="elegibilidade-impedimento" [attr.data-testid]="'elegibilidade-impedimento-' + i">
                        <div class="elegibilidade-impedimento__conteudo">
                          <!-- As condições se somam: todas precisam ser atendidas. -->
                          <p class="elegibilidade-impedimento__regra" data-testid="elegibilidade-impedimento-regra">
                            @if (beneficio.regras.impedimentos.length > 1) {
                              <span class="elegibilidade-impedimento__numero">Regra {{ i + 1 }}</span>
                            }
                            @for (condicao of condicoesImpedimento(regra); track condicao; let ultima = $last) {
                              <span class="elegibilidade-impedimento__condicao">{{ condicao }}</span>
                              @if (!ultima) {
                                <span class="elegibilidade-impedimento__e"> e </span>
                              }
                            }
                          </p>
                          @if (regra.mensagem) {
                            <p class="elegibilidade-impedimento__mensagem" data-testid="elegibilidade-impedimento-mensagem">
                              <vivest-icon name="message-square" source="feather" aria-hidden="true"></vivest-icon>
                              <span><span class="visually-hidden">Mensagem de não elegibilidade: </span>{{ regra.mensagem }}</span>
                            </p>
                          } @else {
                            <p class="elegibilidade-impedimento__mensagem elegibilidade-impedimento__mensagem--vazia">
                              Sem mensagem de não elegibilidade.
                            </p>
                          }
                        </div>
                        <div class="elegibilidade-impedimento__acoes">
                          <vivest-icon-button
                            variant="outline"
                            size="sm"
                            icon="edit-2"
                            icon-source="feather"
                            [attr.aria-label]="'Editar regra ' + (i + 1)"
                            data-testid="elegibilidade-impedimento-editar"
                            (click)="editarImpedimento(regra)"
                          ></vivest-icon-button>
                          <vivest-icon-button
                            variant="outline"
                            size="sm"
                            icon="trash-2"
                            icon-source="feather"
                            [attr.aria-label]="'Excluir regra ' + (i + 1)"
                            data-testid="elegibilidade-impedimento-excluir"
                            (click)="excluirImpedimento(regra.id)"
                          ></vivest-icon-button>
                        </div>
                      </li>
                    }
                  </ol>
                } @else {
                  <p class="elegibilidade__vazio" data-testid="elegibilidade-sem-impedimentos">
                    Sem regras: ser elegível a outro benefício não impede este pedido.
                  </p>
                }
                <vivest-button
                  class="elegibilidade-bloco__acao"
                  variant="outline"
                  size="sm"
                  [disabled]="!outrosBeneficios().length"
                  [attr.title]="outrosBeneficios().length ? null : 'Adicione outro benefício ao plano para criar uma regra'"
                  data-testid="elegibilidade-impedimento-adicionar"
                  (click)="adicionarImpedimento()"
                >
                  <vivest-icon slot="icon-left" name="plus" source="feather"></vivest-icon>
                  Adicionar regra
                </vivest-button>
              </div>
            </section>

            <fieldset class="elegibilidade-bloco" aria-labelledby="elegibilidade-bloco-beneficiarios" formGroupName="beneficiarios" data-testid="elegibilidade-bloco-beneficiarios">
              <div class="elegibilidade-bloco__cabecalho">
                <h4 id="elegibilidade-bloco-beneficiarios" class="elegibilidade-bloco__titulo">Beneficiários</h4>
                <p class="elegibilidade-bloco__regra">Limites para indicar beneficiários no requerimento. Deixe em branco para não limitar.</p>
              </div>
              <div class="elegibilidade-bloco__conteudo">
                <div class="elegibilidade-beneficiarios">
                  <div class="elegibilidade-campo">
                    <label class="campanha-form-label" for="elegibilidade-beneficiarios-quantidade">Quantidade de beneficiários</label>
                    <input
                      id="elegibilidade-beneficiarios-quantidade"
                      type="number"
                      inputmode="numeric"
                      min="1"
                      [max]="beneficiariosMaximo"
                      step="1"
                      placeholder="Sem limite"
                      class="form-control campanha-form-control"
                      formControlName="quantidade"
                      [class.is-invalid]="!!erro('quantidade') || !!erroSomaBeneficiarios()"
                      [attr.aria-describedby]="erro('quantidade') ? 'elegibilidade-beneficiarios-quantidade-erro' : null"
                      data-testid="elegibilidade-beneficiarios-quantidade"
                    />
                    @if (erro('quantidade'); as mensagem) {
                      <p id="elegibilidade-beneficiarios-quantidade-erro" class="elegibilidade__erro" role="alert">{{ mensagem }}</p>
                    }
                  </div>
                  <div class="elegibilidade-campo">
                    <label class="campanha-form-label" for="elegibilidade-beneficiarios-percentual">Percentual mínimo (%)</label>
                    <input
                      id="elegibilidade-beneficiarios-percentual"
                      type="number"
                      inputmode="decimal"
                      min="0.01"
                      max="100"
                      step="0.01"
                      placeholder="Sem mínimo"
                      class="form-control campanha-form-control"
                      formControlName="percentualMinimo"
                      [class.is-invalid]="!!erro('percentualMinimo') || !!erroSomaBeneficiarios()"
                      [attr.aria-describedby]="erro('percentualMinimo') ? 'elegibilidade-beneficiarios-percentual-erro' : null"
                      data-testid="elegibilidade-beneficiarios-percentual"
                    />
                    @if (erro('percentualMinimo'); as mensagem) {
                      <p id="elegibilidade-beneficiarios-percentual-erro" class="elegibilidade__erro" role="alert">{{ mensagem }}</p>
                    }
                  </div>
                </div>
                @if (erroSomaBeneficiarios(); as mensagem) {
                  <p class="elegibilidade__erro" role="alert" data-testid="elegibilidade-erro-beneficiarios">{{ mensagem }}</p>
                }
              </div>
            </fieldset>

            <!-- Observações: texto livre, não é regra. -->
            <div class="elegibilidade-campo elegibilidade-campo--texto elegibilidade-observacoes">
              <label class="campanha-form-label" for="elegibilidade-observacoes">Observações</label>
              <textarea
                id="elegibilidade-observacoes"
                class="form-control campanha-form-control campanha-form-textarea"
                rows="3"
                placeholder="Descreva observações ou condições adicionais"
                [attr.maxlength]="observacoesMaximo"
                formControlName="observacoes"
                [class.is-invalid]="!!erro('observacoes')"
                aria-describedby="elegibilidade-observacoes-contador"
                data-testid="elegibilidade-observacoes"
              ></textarea>
              <p id="elegibilidade-observacoes-contador" class="elegibilidade__contador" data-testid="elegibilidade-observacoes-contador">
                {{ form.controls.observacoes.value.length }}/{{ observacoesMaximo }}
              </p>
              @if (erro('observacoes'); as mensagem) {
                <p class="elegibilidade__erro" role="alert">{{ mensagem }}</p>
              }
            </div>
          </form>
        </section>

        <aside class="elegibilidade-resumo" aria-labelledby="elegibilidade-resumo-titulo" data-testid="elegibilidade-resumo">
          <h3 id="elegibilidade-resumo-titulo" class="elegibilidade-resumo__titulo">
            {{ beneficio.nome }}{{ nomePlano() ? ' (' + nomePlano() + ')' : '' }}
          </h3>
          @if (resumo().condicoes.length) {
            <p class="elegibilidade-resumo__rotulo">Elegível quando:</p>
            <ul class="elegibilidade-resumo__itens" data-testid="elegibilidade-resumo-condicoes">
              @for (item of resumo().condicoes; track $index) {
                <li>{{ item }}</li>
              }
            </ul>
          } @else {
            <p class="elegibilidade-resumo__rotulo">Nenhuma condição definida ainda.</p>
          }
          @if (resumo().excecoes; as excecoes) {
            <p class="elegibilidade-resumo__rotulo">Exceção:</p>
            <p class="elegibilidade-resumo__texto" data-testid="elegibilidade-resumo-excecoes">{{ excecoes }}</p>
          }
        </aside>
      }
    </div>

    <footer class="elegibilidade__rodape">
      @if (temAlteracoes()) {
        <span class="elegibilidade__pendente" data-testid="elegibilidade-alteracoes-pendentes">Há alterações não salvas em {{ selecionado()?.nome }}</span>
      }
      <vivest-button
        variant="outline"
        size="md"
        [disabled]="!temAlteracoes()"
        data-testid="elegibilidade-cancelar"
        (click)="descartar()"
      >
        Cancelar
      </vivest-button>
      <vivest-button
        variant="primary"
        size="md"
        [disabled]="!temAlteracoes()"
        data-testid="elegibilidade-salvar"
        (click)="salvar()"
      >
        <vivest-icon slot="icon-left" name="save" source="feather"></vivest-icon>
        {{ salvando() ? 'Salvando…' : 'Salvar' }}
      </vivest-button>
    </footer>
  }
</section>

<vivest-modal
  heading="Excluir benefício"
  [description]="descricaoExclusao()"
  [open]="!!beneficioAExcluir()"
  [hasIcon]="false"
  dismissible=""
  (vivest-close)="beneficioAExcluir.set(null)"
  data-testid="elegibilidade-excluir-confirmar"
>
  <vivest-button slot="actions" variant="outline" size="md" data-testid="elegibilidade-excluir-voltar" (click)="beneficioAExcluir.set(null)">
    Cancelar
  </vivest-button>
  <vivest-button slot="actions" variant="primary" size="md" data-testid="elegibilidade-excluir-confirmar-btn" (click)="confirmarExclusao()">
    Excluir benefício
  </vivest-button>
</vivest-modal>

@if (selecionandoSituacoes()) {
  <app-situacoes-cadastrais-modal
    [opcoes]="opcoesSituacao()"
    [jaIncluidas]="selecionado()?.regras?.situacoesElegiveis ?? []"
    [descricao]="descricaoModalSituacoes"
    (adicionar)="adicionarSituacoes($event)"
    (fechar)="selecionandoSituacoes.set(false)"
  />
}

@if (impedimentoEmEdicao(); as edicao) {
  <app-impedimento-modal
    [beneficio]="selecionado()?.nome ?? ''"
    [opcoes]="outrosBeneficios()"
    [regra]="edicao.regra"
    (salvar)="salvarImpedimento($event)"
    (fechar)="impedimentoEmEdicao.set(null)"
  />
}

@if (adicionando()) {
  <app-beneficios-modal
    [opcoes]="catalogo()"
    [jaIncluidos]="idsIncluidos()"
    [carregando]="carregandoCatalogo()"
    (adicionar)="adicionarBeneficios($event)"
    (fechar)="adicionando.set(false)"
  />
}

<vivest-modal
  [heading]="'Salvar regras de ' + (selecionado()?.nome ?? '')"
  description="As regras deste benefício passam a valer nas próximas solicitações pelo autoatendimento. Confirma?"
  [open]="confirmandoSalvar()"
  [hasIcon]="false"
  dismissible=""
  (vivest-close)="cancelarSalvar()"
  data-testid="elegibilidade-confirmar"
>
  <vivest-button slot="actions" variant="outline" size="md" data-testid="elegibilidade-confirmar-voltar" (click)="cancelarSalvar()">
    Voltar
  </vivest-button>
  <vivest-button slot="actions" variant="primary" size="md" data-testid="elegibilidade-confirmar-salvar" (click)="confirmarSalvar()">
    Salvar
  </vivest-button>
</vivest-modal>
